import { render } from "./App.vue?vue&type=template&id=77983008"
const script = {}

import "./App.vue?vue&type=style&index=0&id=77983008&lang=css"

import exportComponent from "E:\\UNI\\font\\isa\\academy\\academy-teacher-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__